import { AssigneeRef, assigneeDisplayName, useSystemUsers } from '@Purchasing/Hooks/useSystemUsers/useSystemUsers'
import { cn } from '@/lib/utils'
import { UserAvatar } from './UserAvatar'

/** Avatar + nome do responsável (ou "Sem responsável") para listas e cartões. */
export const AssigneeName = ({ value, size = 'md', className }: { value?: AssigneeRef | null; size?: 'sm' | 'md'; className?: string }) => {
    const { users } = useSystemUsers()
    const name = assigneeDisplayName(value, users)
    if (!name) return <span className={cn('text-muted-foreground', className)}>Sem responsável</span>
    return (
        <span className={cn('inline-flex min-w-0 items-center gap-1.5', className)}>
            <UserAvatar name={name} className={size === 'sm' ? 'h-5 w-5 text-[9px]' : 'h-6 w-6 text-[10px]'} />
            <span className="truncate">{name}</span>
        </span>
    )
}
